import React from 'react';

import type { SpecialtyServiceOptionsEnum } from '@rover/rsdk/src/apiClient/latest/model/specialtyServiceOptionsEnum';

import ServiceSelect from './ServiceSelect';
import useServiceSelectProps from './useServiceSelectProps';

export type CrossVerticalServiceSelectProps = {
  pageServiceTypeSlug: SpecialtyServiceOptionsEnum;
  /** Rendered instead when the page is not showing the cross-vertical selector. */
  staticSelector: JSX.Element;
};

/**
 * The service type selector for the training and grooming search pages. Renders
 * the service types for the other search pages if the experiment is enabled and
 * the endpoints returned the necessary data, otherwise shows the page's specific
 * static service type selector instead.
 */
const CrossVerticalServiceSelect = ({
  pageServiceTypeSlug,
  staticSelector,
}: CrossVerticalServiceSelectProps): JSX.Element => {
  const serviceSelectProps = useServiceSelectProps(pageServiceTypeSlug);

  if (!serviceSelectProps) return staticSelector;

  return <ServiceSelect {...serviceSelectProps} />;
};

export default CrossVerticalServiceSelect;
